export default __webpack_public_path__ + "justhatched.118c4e2b.svg";